import { z } from 'zod';

export const supportSchema = z.object({
  message: z
    .string()
    .trim()
    .min(10, 'validation.supportMin')
    .max(2000, 'validation.supportMax'),
});

export type SupportFormValues = z.infer<typeof supportSchema>;
